import axios from 'axios'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  state: {
    searchBarInfo: null,
    searchPageInfo: null,
    searchPageCategories: [],
    searchPageProducts: [],
    searchBarValue: '',
    suggested: [],
    arrowSelectedItem: {},
    searchBarBufferValue: '',
    isSearchPageLoading: false,
    searchHistory: null,
    shouldHistoryShow: true,
    isInputFocused: false,
    firstLoad: true,
    searchText: null,
    searchFilters: [],
    searchCategories: [],
    searchSort: 'relevance',
    searchPriceRange: null,
    currentRequestUrl: null,
    cancelTokenSource: null
  },
  getters: {
    allPopupItems (state, getters, rootState) {
      const itemsText = [
        {
          text: state.searchBarBufferValue,
          url: getters.urlLanguagePrefix + '/catalog/search/?text=' + state.searchBarBufferValue
        }
      ]

      if (!state.suggested.length && !state.searchBarInfo && state.searchHistory) {
        state.searchHistory.forEach(el => {
          itemsText.push({ text: el.text, url: getters.urlLanguagePrefix + '/catalog/search/?text=' + el.text })
        })
      }

      state.suggested.forEach(el => {
        itemsText.push({ text: el, url: getters.urlLanguagePrefix + '/catalog/search/?text=' + el, isSuggested: true })
      })

      if (state.searchBarInfo) {
        state.searchBarInfo.categories.forEach(el => {
          itemsText.push({ text: el.name[rootState.translation.language], url: el.url, isCategory: true })
        })

        state.searchBarInfo.products.forEach(el => {
          itemsText.push({ text: el.name[rootState.translation.language], url: el.url, isProduct: true })
        })
      }
      return itemsText
    }
  },
  mutations: {
    SET_SEARCH_BAR_INFO (state, info) {
      if (!info) {
        state.searchBarInfo = null
        return
      }
      state.searchBarInfo = { ...state.searchBarInfo, ...info }
    },
    SET_SEARCH_PAGE_INFO (state, info) {
      if (info.filters && !Array.isArray(info.filters)) {
        info.filters.price = info.filters['Ціна'] || info.filters['Cena']
      }

      if (info.filters && !Array.isArray(info.filters)) {
        info.filters.price = info.filters['Ціна'] || info.filters['Cena']
        delete info.filters['Ціна']
        delete info.filters['Cena']
      }
      state.searchPageInfo = { ...state.searchPageInfo, ...info }

      const filters = []

      for (const filter in info.selected_filters) {
        for (const subfilter of info.selected_filters[filter]?.values || []) {
          filters.push(`${filter}_${subfilter}`)
        }
      }

      state.searchFilters = [ ...filters ]

      state.searchPriceRange = { from: info?.filters?.price?.range?.from, to: info?.filters?.price?.range?.to }
    },
    SET_SEARCH_PAGE_CATEGORIES (state, info) {
      state.searchPageCategories = info
    },
    SET_SEARCH_BAR_VALUE (state, str) {
      state.searchBarValue = str
    },
    SET_SUGGESTIONS (state, info) {
      state.suggested = info
    },
    SET_ARROW_SELECTED_ITEM (state, text) {
      state.arrowSelectedItem = text
    },
    SET_BUFFER_VALUE (state, value) {
      state.searchBarBufferValue = value
    },
    SET_SEARCH_PAGE_LOADING (state, bool) {
      state.isSearchPageLoading = bool
    },
    SET_SEARCH_HISTORY (state, history) {
      state.searchHistory = history
    },
    SET_SHOULD_HISTORY_SHOW (state, bool) {
      state.shouldHistoryShow = bool
    },
    SET_INPUT_FOCUSED (state, bool) {
      state.isInputFocused = bool
    },
    SET_FIRST_LOAD_FLAG (state, bool) {
      state.firstLoad = bool
    },
    CLEAR_SEARCH_PAGE_PRODUCTS (state) {
      state.searchPageProducts = []
    },
    APPEND_SEARCH_FILTER (state, filter) {
      state.searchFilters = [...state.searchFilters, filter]
    },
    REMOVE_SEARCH_FILTER (state, filterSlug) {
      state.searchFilters = state.searchFilters.filter(slug => slug !== filterSlug)
    },
    APPEND_SEARCH_CATEGORY (state, category) {
      state.searchCategories = [...state.searchCategories, category]
    },
    REMOVE_SEARCH_CATEGORY (state, categoryId) {
      state.searchCategories = state.searchCategories.filter(itemId => itemId !== categoryId)
    },
    REMOVE_ALL_SEARCH_FILTERS (state) {
      state.searchCategories = []
      state.searchFilters = []
      state.searchPriceRange = null
      state.searchSort = 'relevance'
    },
    SET_SEARCH_PRICE_RANGE (state, priceRange) {
      if (Number.isFinite(priceRange.from) && Number.isFinite(priceRange.to)) {
        state.searchPriceRange = priceRange
      }
    },
    SET_SEARCH_PAGE_TEXT (state, text) {
      state.searchText = text
    },
    SET_CURRENT_URL (state, url) {
      state.currentRequestUrl = url
    },
    SET_CANCEL_TOKEN_SOURCE (state, source) {
      state.cancelTokenSource = source
    },
    SET_RELEVANT_PRODUCT_LIST (state) {
      const info = state.searchPageInfo

      if (info.products && !Array.isArray(info.products)) {
        state.searchPageProducts = [...state.searchPageProducts, ...info.products.products]
      }
    },
    SET_SEARCH_SORT (state, sort) {
      state.searchSort = sort
    }
  },
  actions: {
    FETCH_SEARCH_BAR_INFO ({ commit, rootGetters, dispatch }, str) {
      commit('SET_BUFFER_VALUE', str)

      if (!str) {
        commit('SET_SEARCH_BAR_INFO', null)
        commit('SET_SHOULD_HISTORY_SHOW', true)
        commit('SET_SUGGESTIONS', [])
        return
      }

      axios
        .get(rootGetters.urlLanguagePrefix + '/search/drop-down/?q=' + str)
        .then(response => {
          commit('SET_SEARCH_BAR_INFO', response.data)

          if (response.data?.suggests) {
            commit('SET_SUGGESTIONS', response.data.suggests)
          }

          if (response?.data?.products?.length) {
            response.data.products.forEach((product, index) => {
              GoogleTagManagerService.productViewEvent({
                analyticsData: [
                  {
                    'name': product.name.ru,
                    'id': product.id,
                    'price': product.price_new,
                    'category': product.category_parent_id + '/' + product.category_id,
                    'list': 'Suggest Results',
                    'position': index + 1
                  }
                ]
              })
            })
          }
        })
        .finally(() => commit('SET_SHOULD_HISTORY_SHOW', false))
    },
    UPDATE_SEARCH_URL ({ state }) {
      const params = new URLSearchParams()
      params.set('text', state.searchText)

      if (state.searchSort !== 'relevance') {
        params.set('sort', state.searchSort)
      }

      if (state.searchPriceRange && (state.searchPriceRange.from !== state.searchPageInfo?.filters?.price?.range?.min || state.searchPriceRange.to !== state.searchPageInfo?.filters?.price?.range?.max)) {
        params.set('price_from', state.searchPriceRange.from)
        params.set('price_to', state.searchPriceRange.to)
      }

      state.searchCategories.forEach(categoryId => params.append('c', categoryId))
      state.searchFilters.forEach(filter => params.append('f', filter))

      const newUrl = `${window.location.origin}${window.location.pathname}?${params.toString()}`
      window.history.pushState(null, '', newUrl)
    },
    UPDATE_FETCH_URL ({ commit, state, rootGetters }) {
      const price = state.searchPriceRange && (state.searchPriceRange.from !== state.searchPageInfo?.filters?.price?.range?.min || state.searchPriceRange.to !== state.searchPageInfo?.filters?.price?.range?.max)
        ? '&' + `price_from=${state.searchPriceRange.from}&price_to=${state.searchPriceRange.to}` : ''
      const categories = state.searchCategories.length ? '&' + state.searchCategories.map(categoryId => 'c[]=' + categoryId).join('&') : ''
      const filters = state.searchFilters.length ? '&' + state.searchFilters.map(filter => 'f[]=' + filter).join('&') : ''
      const sort = state.searchSort !== 'relevance' ? '&s=' + state.searchSort : ''
      let newRequestUrl = rootGetters.urlLanguagePrefix + `/search/page/?q=${state.searchText}` + price + categories + filters + sort

      if (newRequestUrl !== state.currentRequestUrl) {
        commit('SET_FIRST_LOAD_FLAG', true)
      }
      commit('SET_CURRENT_URL', newRequestUrl)
    },
    FETCH_SEARCH_PAGE_INFO ({ commit, dispatch, state }, isUpdateProductList) {
      if (state.cancelTokenSource) {
        state.cancelTokenSource.cancel('Fetch was canceled')
      }

      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      commit('SET_CANCEL_TOKEN_SOURCE', source)
      dispatch('UPDATE_FETCH_URL')
      commit('SET_SEARCH_PAGE_LOADING', true)

      if (state.firstLoad && isUpdateProductList) {
        commit('CLEAR_SEARCH_PAGE_PRODUCTS')
      }

      const fetchUrl = state.firstLoad ? state.currentRequestUrl : `${state.currentRequestUrl}&offset=${state.searchPageInfo.products.offset}`

      axios
        .get(fetchUrl, { cancelToken: source.token })
        .then(response => {
          commit('SET_SEARCH_PAGE_CATEGORIES', response.data?.categories ?? [])
          commit('SET_SEARCH_SORT', response.data?.selected_sort ?? 'relevance')
          commit('SET_SEARCH_PAGE_INFO', response.data)
          commit('SET_SEARCH_PAGE_LOADING', false)
          commit('SET_FIRST_LOAD_FLAG', false)

          if (isUpdateProductList) {
            dispatch('SET_RELEVANT_SEARCH_PRODUCT_LIST', false)
          }
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            commit('SET_SEARCH_PAGE_LOADING', false)
          }
        })
    },
    SET_FROM_KEYBOARD ({ commit, getters }, index) {
      commit('SET_SEARCH_BAR_VALUE', getters.allPopupItems[index - 1].text)
      commit('SET_ARROW_SELECTED_ITEM', getters.allPopupItems[index - 1])
    },
    REMOVE_ARROW_SELECTED_ITEM ({ commit }) {
      commit('SET_ARROW_SELECTED_ITEM', {})
    },
    FETCH_SEARCH_HISTORY ({ commit, rootGetters, state }) {
      if (state.searchHistory === false || state.searchHistory === '' || state.searchHistory) return
      commit('SET_SEARCH_HISTORY', false)

      axios
        .get(rootGetters.urlLanguagePrefix + '/search/history/')
        .then(response => commit('SET_SEARCH_HISTORY', response.data))
    },
    SET_SEARCH_BAR_VALUE_ACTION ({ commit }, str) {
      commit('SET_SEARCH_BAR_VALUE', str)
    },
    CLEAR_HISTORY ({ rootGetters, commit }) {
      axios
        .get(rootGetters.urlLanguagePrefix + '/search/clear-history/')
        .then(response => {
          if (response.data.success) {
            commit('SET_SEARCH_HISTORY', null)
          } else commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred'))
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred')))
    },
    SET_INPUT_FOCUSED_ACTION ({ commit }, bool) {
      commit('SET_INPUT_FOCUSED', bool)
    },
    SEND_SUGGEST_HISTORY ({ rootGetters }, value) {
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/search/set-suggest-history/?text=' + value)
          .then(res => resolve(res.data))
          .catch(err => reject(err))
      })
    },
    APPEND_FILTER ({ commit }, filter) {
      commit('APPEND_SEARCH_FILTER', filter)
    },
    REMOVE_FILTER ({ commit }, filter) {
      commit('REMOVE_SEARCH_FILTER', filter)
    },
    APPEND_CATEGORY ({ commit, state }, category) {
      commit('APPEND_SEARCH_CATEGORY', category)
    },
    REMOVE_CATEGORY ({ commit }, categoryId) {
      commit('REMOVE_SEARCH_CATEGORY', categoryId)
    },
    CLEAR_ALL_SEARCH_FILTERS ({ commit }) {
      commit('REMOVE_ALL_SEARCH_FILTERS')
    },
    SET_PRICE_RANGE ({ commit }, price) {
      commit('SET_SEARCH_PRICE_RANGE', price)
    },
    SET_SEARCH_TEXT ({ commit }, text) {
      commit('SET_SEARCH_PAGE_TEXT', text)
    },
    SET_SEARCH_SORT_METHOD ({ commit }, sort) {
      commit('SET_SEARCH_SORT', sort)
    },
    RESTORE_PRICE ({ commit, state }) {
      if (state.searchPageInfo && state.searchPageInfo.filters && state.searchPageInfo.filters.price && state.searchPageInfo.filters.price.range) {
        commit('SET_SEARCH_PRICE_RANGE', { from: state.searchPageInfo.filters.price.range.min, to: state.searchPageInfo.filters.price.range.max })
      }
    },
    SET_RELEVANT_SEARCH_PRODUCT_LIST ({ commit, dispatch }, isClearProducts) {
      if (isClearProducts) {
        commit('CLEAR_SEARCH_PAGE_PRODUCTS')
      }
      commit('SET_RELEVANT_PRODUCT_LIST')
      dispatch('UPDATE_SEARCH_URL')
    }
  }
}
